const MINUTES_IN_HOUR = 60;

// Lead time (how long before the route starts) for the "Delivery scheduled" notification.
// A null threshold means "send when the route is published". When sending "before route
// start", the user picks one of these fixed options. Values are in MINUTES — that is the
// unit `deliveryScheduledThreshold` is stored/sent in. The label maps each minute value to
// a friendly "30 minutes" / "1 hour" string, and is relative to the `customerNotifications`
// namespace, so callers in other namespaces must prefix it.
export const DELIVERY_SCHEDULED_LEAD_TIME_OPTIONS: { value: number; labelKey: string }[] = [
  { value: 30, labelKey: 'editTemplate.deliveryScheduledTiming.leadTimeOptions.30m' },
  { value: 1 * MINUTES_IN_HOUR, labelKey: 'editTemplate.deliveryScheduledTiming.leadTimeOptions.1h' },
  { value: 2 * MINUTES_IN_HOUR, labelKey: 'editTemplate.deliveryScheduledTiming.leadTimeOptions.2h' },
  { value: 4 * MINUTES_IN_HOUR, labelKey: 'editTemplate.deliveryScheduledTiming.leadTimeOptions.4h' },
  { value: 24 * MINUTES_IN_HOUR, labelKey: 'editTemplate.deliveryScheduledTiming.leadTimeOptions.24h' },
];

// Default selection when switching to "before route start" — 1 hour (in minutes).
export const DEFAULT_DELIVERY_SCHEDULED_LEAD_TIME_MINUTES = 1 * MINUTES_IN_HOUR;

// A stored threshold need not match a preset: it may predate a change to the options above, or
// have been set outside the app. Those fall back to a generic "{{count}} minutes" label.
export const getDeliveryScheduledLeadTimeLabel = (minutes: number): { key: string; count?: number } => {
  const preset = DELIVERY_SCHEDULED_LEAD_TIME_OPTIONS.find((option) => option.value === minutes);

  return preset
    ? { key: preset.labelKey }
    : { key: 'editTemplate.deliveryScheduledTiming.customLeadTime', count: minutes };
};
